export default "__VITE_ASSET__dc6db940__"